'use client';

import { LanguageObject } from "@/components/Types";
import { NATIVE_LANGUAGES } from "@/lib/constants";
import { MOBILE_BREAKPOINT } from "@/lib/constants-ui";
import { LearningFeedPost } from "@/lib/types/feed";
import { Breadcrumbs, BreadcrumbItem } from "@heroui/react";
import { useEffect, useState } from "react";

export default function BreadcrumbsElement({nativeLanguage, topic, language, t}: {nativeLanguage: string, topic: string, language: string, t: any}) {
    const [isMobile, setIsMobile] = useState(null);

    useEffect(() => {
        setIsMobile((window as any)?.innerWidth < MOBILE_BREAKPOINT);
    }, []);

    const decodedTopic = decodeURIComponent(topic);

    const nativeLanguageKey = (Object.keys(NATIVE_LANGUAGES).find((language) => NATIVE_LANGUAGES[language].code?.toLowerCase() == nativeLanguage.toLowerCase()) as any);;
    const nativeLanguageObject = NATIVE_LANGUAGES[nativeLanguageKey as keyof typeof NATIVE_LANGUAGES];    

    return (
        <div>
            <Breadcrumbs classNames={{
                list: "gap-y-2",
            }} size={isMobile ? "sm" : "md"} radius={isMobile ? "none" : "full"} variant={isMobile ? "light" : "bordered"} underline="active">
                    <BreadcrumbItem>{t.languages[language]}</BreadcrumbItem>
                    <BreadcrumbItem href={`/learn/${language}/${nativeLanguage}`}>{nativeLanguageObject?.emoji}</BreadcrumbItem>
                    <BreadcrumbItem isCurrent={true} isLast={true}>{t.topics[decodedTopic] ?? decodedTopic}</BreadcrumbItem>
            </Breadcrumbs>
        </div>
    );
}